module.exports = __webpack_public_path__ + "img/camera_fault.9b10c050.svg";